var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4362_6603)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4362_6603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7454 18.7148V17.0482C16.7454 16.1641 16.3943 15.3163 15.7691 14.6912C15.144 14.066 14.2962 13.7148 13.4121 13.7148H6.74544C5.86139 13.7148 5.01354 14.066 4.38842 14.6912C3.7633 15.3163 3.41211 16.1641 3.41211 17.0482V18.7148M21.7454 18.7148V17.0482C21.7449 16.3096 21.4991 15.5922 21.0466 15.0084C20.5941 14.4247 19.9605 14.0078 19.2454 13.8232M15.9121 3.82318C16.6291 4.00676 17.2646 4.42376 17.7185 5.00844C18.1723 5.59311 18.4186 6.3122 18.4186 7.05234C18.4186 7.79249 18.1723 8.51158 17.7185 9.09625C17.2646 9.68093 16.6291 10.0979 15.9121 10.2815M13.4121 7.04818C13.4121 8.88913 11.9197 10.3815 10.0788 10.3815C8.23783 10.3815 6.74544 8.88913 6.74544 7.04818C6.74544 5.20723 8.23783 3.71484 10.0788 3.71484C11.9197 3.71484 13.4121 5.20723 13.4121 7.04818Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4362_6603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.332031)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4362_6603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.57812 1.21484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/Icon_People.ace70b3e296204001117a1e6f50caebe.svg";
export { ForwardRef as ReactComponent };